var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,{ref:"icon",tag:"component",staticClass:"icon",class:_vm.type,attrs:{"id":_vm.type,"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }